module.exports = __webpack_public_path__ + "img/kortimilli.465cb575.svg";